import AmountInput from "app/common/components/AmountInput";
import ConditionalRender from "app/common/components/ConditionalRender";
import CustomBankSelect from "app/common/components/CustomBankSelect";
import CustomCheckbox from "app/common/components/CustomCheckbox";
import CustomCountrySelect from "app/common/components/CustomCountrySelect";
import CustomCurrencySelect from "app/common/components/CustomCurrencySelect";
import CustomDatePicker from "app/common/components/CustomDatePicker";
import CustomInputAutoComplete from "app/common/components/CustomInputAutoComplete";
import CustomPasswordField from "app/common/components/CustomPasswordField";
import CustomPhoneInput from "app/common/components/CustomPhoneInput";
import CustomRadio from "app/common/components/CustomRadio";
import CustomSelect from "app/common/components/CustomSelect";
import InputError from "app/common/components/InputError";
import InputWithFix from "app/common/components/InputWithFix";

const FormInput = ({label, invalidMessage, contClass, validation, desc, ...props}) => {

    return  <div className={contClass}>
                {
                    label &&    <label className="form-label">
                                    {label}
                                </label>
                }
                {{
                    "currency": <CustomCurrencySelect {...props} />,
                    "amount": <AmountInput {...props} />,
                    "textarea": <textarea className="form-input" {...props} />,
                    "autocomplete": <CustomInputAutoComplete className="form-input" {...props} />,
                    "bank": <CustomBankSelect {...props} />,
                    "country": <CustomCountrySelect {...props} />,
                    "radio": <CustomRadio {...props} />,
                    "checkbox": <CustomCheckbox {...props} />,
                    "select": <CustomSelect {...props} />,
                    "date": <CustomDatePicker {...props} />,
                    "phone": <CustomPhoneInput {...props} />,
                    "password": <CustomPasswordField {...props} />
                }[props.type] || <InputWithFix type="text" {...props} />}
                <ConditionalRender
                    render={desc}
                >
                    <div className="text-sm pt-2 text-grey-6">{desc}</div>
                </ConditionalRender>
                <InputError
                    name={props.name}
                    validation={validation}
                    text={invalidMessage ?? props.placeholder}
                />
            </div>
}

export default FormInput;